"use strict";

import jQuery from "jquery";
import mixitup from 'mixitup';
import Flickity from 'flickity';
import 'flickity-fade';
import 'flickity-as-nav-for';

import 'flickity/dist/flickity.css';

import '../scss/app.scss'

import '@fancyapps/fancybox';

import '../../node_modules/@fancyapps/fancybox/dist/jquery.fancybox.min.css';

(function( $ ) {

	$.fn.setImg = function() {
		var bg = $(this).data('img');
		$(this).css({
			'background-image': 'url(' + bg + ')'
		});
	};

	var getUrlParameter = function getUrlParameter(sParam) {
	    var sPageURL = window.location.search.substring(1),
	        sURLVariables = sPageURL.split('&'),
	        sParameterName,
	        i;

	    for (i = 0; i < sURLVariables.length; i++) {
	        sParameterName = sURLVariables[i].split('=');

	        if (sParameterName[0] === sParam) {
	            return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
	        }
	    }
	};

	$(function() {

		$('.imgToDiv').each(function(index, elem) {
			$(elem).setImg();
		});

		if($('.slideshow').length) {
			var slideshow = new Flickity('.slideshow', {
				fade: true,
				wrapAround: true,
				autoPlay: 5000,
				pauseAutoPlayOnHover: false,
				pageDots: false
			});
		}

		if($('.carousel').length) {
			var carousel = new Flickity('.carousel', {
				cellAlign: 'left',
				wrapAround: true,
				autoPlay: 5000,
				pauseAutoPlayOnHover: false,
				pageDots: false
			});
		}

		if($('.gallery').length && $('.thumbnails').length) {
			var gallery = new Flickity('.gallery', {
				wrapAround: true,
				pageDots: false,
				prevNextButtons: false
			});
			var thumbnails = new Flickity('.thumbnails', {
				asNavFor: '.gallery',
				contain: true,
				pageDots: false,
				prevNextButtons: false
			});
		}

		if($('.realizzazioni .mixer').length) {
			var mixer = mixitup('.mixer');
			mixer.filter(':not(.description)', false);
			var settore = getUrlParameter('settore-attivo');
			$('.realizzazioni input[name="filter"][data-filter=".' + settore + '"]').trigger("click");
		}

		$('.hamburger').on('click', function() {
			$(this).toggleClass('is-active');
			$('.header').toggleClass('open');
		});

	});

})(jQuery);